(function () {
  if (window.sodEmailSignupAjaxLoaded) return;
  window.sodEmailSignupAjaxLoaded = true;

  async function submitEmailSignup(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-email-signup-ajax]')) return false;

    event.preventDefault();
    event.stopPropagation();

    if (!form.reportValidity() || form.dataset.submitting === 'true') return false;

    var successMessage = form.querySelector('[data-email-signup-success]');
    var errorMessage = form.querySelector('[data-email-signup-error]');
    var errorText = form.querySelector('[data-email-signup-error-text]');
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var buttonHtml = button ? button.innerHTML : '';

    form.dataset.submitting = 'true';
    if (successMessage) successMessage.hidden = true;
    if (errorMessage) errorMessage.hidden = true;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = button.dataset.loadingMessage || 'Submitting…';
    }

    try {
      var response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
        credentials: 'same-origin',
      });
      var responseUrl = new URL(response.url, window.location.origin);

      if (!response.ok || responseUrl.searchParams.get('customer_posted') !== 'true') {
        throw new Error('Unable to subscribe. Please try again.');
      }

      form.reset();
      if (input) input.removeAttribute('aria-invalid');
      if (successMessage) successMessage.hidden = false;
    } catch (error) {
      if (input) input.setAttribute('aria-invalid', 'true');
      if (errorText) {
        errorText.textContent = error instanceof Error ? error.message : 'Unable to subscribe. Please try again.';
      }
      if (errorMessage) errorMessage.hidden = false;
    } finally {
      delete form.dataset.submitting;
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.innerHTML = buttonHtml;
      }
    }

    return false;
  }

  window.sodEmailSignupSubmit = submitEmailSignup;
  window.addEventListener('submit', submitEmailSignup, true);
})();
